const ROLES = {
  CUSTOMER: {
    id: 1,
    title: 'Customer',
  },
  ADMIN: {
    id: 2,
    title: 'Admin',
  },
  PRO: {
    id: 3,
    title: 'Pro',
  },
  PRO_CANDIDATE: {
    id: 4,
    title: 'Pro candidate',
  },
  SALES_MANAGER: {
    id: 5,
    title: 'Sales manager',
  },
  SALES_HEAD: {
    id: 10,
    title: 'Sales head',
  },
  SUPPLY_MANAGER: {
    id: 6,
    title: 'Support manager',
  },
  CONTENT_MANAGER: {
    id: 7,
    title: 'Content manager',
  },
  FINANCE_MANAGER: {
    id: 8,
    title: 'Finance manager',
  },
  PROJECT_MANAGER: {
    id: 9,
    title: 'Project manager',
  },
};

ROLES.LIST = [
  ROLES.CUSTOMER,
  ROLES.ADMIN,
  ROLES.PRO,
  ROLES.PRO_CANDIDATE,
  ROLES.SALES_MANAGER,
  ROLES.SALES_HEAD,
  ROLES.SUPPLY_MANAGER,
  ROLES.CONTENT_MANAGER,
  ROLES.FINANCE_MANAGER,
  ROLES.PROJECT_MANAGER,
];

ROLES.ID_TO_TITLE = {
  [ROLES.CUSTOMER.id]: ROLES.CUSTOMER,
  [ROLES.ADMIN.id]: ROLES.ADMIN,
  [ROLES.PRO.id]: ROLES.PRO,
  [ROLES.PRO_CANDIDATE.id]: ROLES.PRO_CANDIDATE,
  [ROLES.SALES_MANAGER.id]: ROLES.SALES_MANAGER,
  [ROLES.SALES_HEAD.id]: ROLES.SALES_HEAD,
  [ROLES.SUPPLY_MANAGER.id]: ROLES.SUPPLY_MANAGER,
  [ROLES.CONTENT_MANAGER.id]: ROLES.CONTENT_MANAGER,
  [ROLES.FINANCE_MANAGER.id]: ROLES.FINANCE_MANAGER,
  [ROLES.PROJECT_MANAGER.id]: ROLES.PROJECT_MANAGER,
};

ROLES.MANAGERS_ROLES_LIST = [
  ROLES.ADMIN,
  ROLES.SALES_MANAGER,
  ROLES.SALES_HEAD,
  ROLES.SUPPLY_MANAGER,
  ROLES.CONTENT_MANAGER,
  ROLES.FINANCE_MANAGER,
  ROLES.PROJECT_MANAGER,
];

const LOGIN_REDIRECTS = {
  [ROLES.CUSTOMER.id]: 'client',
  [ROLES.PRO_CANDIDATE.id]: 'booster__dashboard',
  [ROLES.PRO.id]: 'booster__dashboard',
  [ROLES.ADMIN.id]: 'admin',
  [ROLES.SALES_MANAGER.id]: 'admin-orders__all',
  [ROLES.SALES_HEAD.id]: 'admin',
  [ROLES.SUPPLY_MANAGER.id]: 'admin-orders__all',
  [ROLES.CONTENT_MANAGER.id]: 'admin-products',
  [ROLES.FINANCE_MANAGER.id]: 'finance-reports',
  [ROLES.PROJECT_MANAGER.id]: 'admin-orders__all',
};

const SHIFT_TYPES = {
  DAY: {
    id: 1,
    title: 'Day',
  },
  NIGHT: {
    id: 2,
    title: 'Night',
  },
};

SHIFT_TYPES.LIST = [
  SHIFT_TYPES.DAY,
  SHIFT_TYPES.NIGHT,
];

SHIFT_TYPES.ID_TO_DATA = {
  [SHIFT_TYPES.DAY.id]: SHIFT_TYPES.DAY,
  [SHIFT_TYPES.NIGHT.id]: SHIFT_TYPES.NIGHT,
};

const SET_PASSWORD_TOKEN_NAME = 'skycoach_token';
const EMAIL_VERIFY_LATER_TOKEN_NAME = 'email_verify_later';
const SET_PASSWORD_LATER_TOKEN_NAME = 'set_password_later';

/* eslint-disable no-bitwise */
const INTERNAL_BIT_FLAGS = {
  BLOCKED_SCAMMERS_APPROVED: 1 << 0,
};
/* eslint-enable no-bitwise */

const UserModel = {
  ROLES,
  SHIFT_TYPES,
  LOGIN_REDIRECTS,
  SET_PASSWORD_TOKEN_NAME,
  EMAIL_VERIFY_LATER_TOKEN_NAME,
  SET_PASSWORD_LATER_TOKEN_NAME,
  INTERNAL_BIT_FLAGS,
};

export default UserModel;
